import type { ReactNode } from 'react';
import styled from 'styled-components';

import { HalfCircularProgressBar } from '@sorare/core/src/atoms/loader/CircularProgressIndicator/HalfCircularProgressBar';
import { WidgetButton } from '@sorare/core/src/atoms/ui/WidgetButton/index.tsx';
import type { Unit } from '@sorare/core/src/lib/style.ts';

import { IconWrapper } from '#src/components/series/SeriesMissions/ui.tsx';

import icon from './assets/icon.svg';

const Img = styled.img`
  object-fit: contain;
`;

type Props = {
  chip: ReactNode;
  to: string;
  size?: Unit;
};

export const DumbPlayMissionWidget = ({ chip, to, size = 6 }: Props) => (
  <WidgetButton to={to} chip={chip}>
    <HalfCircularProgressBar
      size={size}
      progresses={[1]}
      colors={[
        {
          from: 'var(--c-arena-primary)',
          to: 'var(--c-arena-primary)',
        },
      ]}
      backgroundColor="var(--c-arena-tertiary)"
    />
    <IconWrapper>
      <Img
        src={icon}
        alt=""
        style={{
          width: `calc(${size} * var(--unit) - var(--double-unit))`,
          height: `calc(${size} * var(--unit) - var(--double-unit))`,
        }}
      />
    </IconWrapper>
  </WidgetButton>
);
